import {
  brandColor,
  getClassTextForColor,
  getEditorColor,
  renderColor,
} from '../../util/ColorUtil';
import React, { useState } from 'react';
import CtaBarButton from '../base/cta-bar-button';
import FacilityModal from '../modal/FacilityModal';
import Image from 'next/image';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';

const Testimonial = ({ data, lang, global }) => {
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  let showSeparator = !!(
    data?.field_title_field[0]?.value || data?.field_second_line[0]?.value
  );
  let isButton = !!data?.field_cta_bar_button_selection[0]?.cta_bar_button;
  let isQuote = data?.field_title_color[0]?.value?.includes('blockquote');
  let fullItems = isQuote && isButton && showSeparator;
  let hasTextOrButton = showSeparator || isButton;
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.field_title_color),
    isItUndefined(data?.field_description)
  ).filter((x) => x)[0];

  return (
    <div
      className={
        'testimonial ' +
        getClassTextForColor(data?.field_background_color[0]?.value) +
        ' quote-' +
        isQuote +
        ' full-items-' +
        fullItems
      }
      style={{
        backgroundColor: brandColor(data?.field_background_color[0]?.value),
      }}
    >
      <div className={'inner-container'}>
        <div
          className={`help-width ${!data?.field_image[0] ? 'no-image' : ''}`}
        >
          <span
            className={`text ${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(modifyLinks(data?.field_title_color[0]?.value)),
            }}
          />
          <div
            className={
              'bottom separator-' + showSeparator + ' button-' + isButton
            }
          >
            <div className={`left`}>
              {data?.field_image[0] && (
                <Image
                  alt={'image'}
                  layout={'fill'}
                  src={data?.field_image[0]}
                />
              )}
              <div className={'name-job'}>
                <span className={'name'}>{data?.field_title[0]?.value}</span>
                <span
                  className={`job ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                  dangerouslySetInnerHTML={{
                    __html: cleanHTML(
                      modifyLinks(data?.field_description[0]?.value)
                    ),
                  }}
                />
              </div>
            </div>
            {hasTextOrButton && (
              <div className={'right'}>
                {showSeparator && (
                  <div className={'inner-left'}>
                    {data?.field_second_line[0]?.value && (
                      <span className={'small-text'}>
                        {data?.field_second_line[0].value}
                      </span>
                    )}
                    {data?.field_title_field[0]?.value && (
                      <span className={'title'}>
                        {data?.field_title_field[0].value}
                      </span>
                    )}
                  </div>
                )}
                {data?.field_cta_bar_button_selection[0]?.cta_bar_button && (
                  <CtaBarButton
                    blockTypeClass={'testimonial'}
                    bgColor={renderColor(
                      getEditorColor(
                        brandColor(data?.field_background_color[0]?.value)
                      )
                    )}
                    setMarketoTrigger={setMarketoTrigger}
                    data={
                      data?.field_cta_bar_button_selection[0]?.cta_bar_button
                    }
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {marketoTrigger && (
        <FacilityModal
          lang={lang}
          global={global}
          setTrigger={setMarketoTrigger}
          trigger={marketoTrigger}
        >
          {data.field_marketo_blocks[0]?.marketo_form_facility_block_type}
        </FacilityModal>
      )}
    </div>
  );
};

export default Testimonial;
